export default "/36022bc732d21dcfe768d2a0d43278c292b1a1e5/b552ae94a3baa9664c4076d726380c66.svg";